import { render, staticRenderFns } from "./Proposta.vue?vue&type=template&id=2fc8b0f4&"
import script from "./Proposta.vue?vue&type=script&lang=js&"
export * from "./Proposta.vue?vue&type=script&lang=js&"
import style0 from "./Proposta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports